import type { ReactNode } from 'react';
import { isViewerPath } from '../utils/viewerPath';

/**
 * The shell's silhouette while there is nothing to put in it yet: auth
 * resolving, a lazy page chunk downloading. Same band and ground as the real
 * shell (and as the static placeholder in index.html), so a full document
 * load changes only the pane's contents, never the frame around it.
 */
export function BootShell({ children }: { children?: ReactNode }) {
  const viewer = isViewerPath(window.location.pathname);
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-ground">
      {/* Below xl the shell's nav wraps onto a second 41px row. */}
      <header
        className={`shrink-0 bg-header ${viewer ? 'h-[52px]' : 'h-[93px] xl:h-[52px]'}`}
      />
      {viewer ? (
        <div className="min-h-0 flex-1 bg-surface">{children}</div>
      ) : (
        <main className="min-h-0 flex-1 p-3">
          <div className="pane h-full overflow-hidden">{children}</div>
        </main>
      )}
    </div>
  );
}
